module.exports = __webpack_public_path__ + "img/ico-filter.570e1d79.svg";